import { staticImagesRelativePath } from './staticImagesRelativePath';

export const checkAndReturnIconForIntegration = (iconName: string) => {
  if (iconName in staticImagesRelativePath.integrationIcons) {
    return iconName;
  }
  return 'DEFAULT';
};
